// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-title span {
  font-family: Noto Sans;
  font-weight: 400;
  font-size: 22px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000000;
}

.create-contract {
  width: 139px !important;
  height: 40px;
  width: fit-content;
  border-radius: 4px;
  background: #FDE802;
  border-style: none;
}

.create-contract span {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Noto Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #292F36;
}

.status-dropdown {
  width: 238px;
  display: flex;
  align-items: center;
  height: 40px;
}

.status-dropdown.p-dropdown {
  border: 1px solid #292F36 !important;
}

.status-dropdown .p-dropdown-label {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0;
  color: #000;
}

.project-conatiner {
  border-radius: 8px;
  border-width: 1px;
  background: #FFFFFF;
  border: 1px solid #C8CED3;
}

.status-update {
  /* width: 96px; */
  padding: 12px,12px;
  border-radius: 20px;
  background: #ED0006;
}

.status-update span {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Noto Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #F3F3F3;
}

.change-requested {
  width: 150px;
  border-radius: 20px;
  background: #1A1A1A;
}

.change-requested span {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Noto Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #F3F3F3
}

.completed-requested {
  width: 109px;
  border-radius: 20px;
  background: #128807;
}

.completed-requested span {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Noto Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #F3F3F3
}

@media (max-width: 768px) {
  .change-requested {
    width: auto;
    border-radius: 20px;
    background: #1A1A1A;
  }

  .create-contract {
    height: 40px;
    /* width: 100%; */
    border-radius: 4px;
    background: #FDE802;
    border-style: none;
  }

  contract span {
    display: flex;
    font-family: Noto Sans;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0%;
    color: #292F36;
    justify-content: center;
    align-items: center;
  }

  .status-dropdown {
    /* width:100%; */
    display: flex;
    align-items: center;
    height: 40px;
  }
}

.project-title span {
  font-family: Noto Sans;
  font-weight: 600;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #292F36
}

.border-style {
  border: 1px solid #C8CED3;
}

.course-title span {
  font-family: Noto Sans;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #565B60
}

.date span {
  font-family: Noto Sans;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #565B60
}

.date img {
  height: 16px;
  width: 16px;
}

.total-count span {
  font-family: Noto Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #292F36;
}

.view-btn {
  border-style: none;
  width: 93px;
  border-radius: 4px;
  background: #FDE802;
}

.change-btn {
  border-style: none;
  width: 93px;
  border-radius: 4px;
  background: #FDE802;
}

.view-btn span {
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
  font-family: Noto Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #292F36;
}

.Creator span {
  font-family: Noto Sans;
  font-weight: 400;
  font-size: 17px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #565B60;
}

.comment-conatiner {
  background: #ffff;
  border: 1px solid #999C9F;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.comment-conatiner span {
  font-family: Noto Sans;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0%;
  color: #292F36;
}

.reciver-message {
  width: 32px;
  height: 32px;
  border-radius: 30px;
  background: #999C9F;
}

.reciver-message span {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #FFFFFF;
}

.message-text {
  font-family: Noto Sans;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000000;
  flex: 1 1;
}

.reply-style {
  font-family: Noto Sans !important;
  font-weight: 700 !important;
  font-size: 14.5px !important;
  line-height: 24px !important;
  letter-spacing: 0% !important;
  color: #000 !important;
  ;
  cursor: pointer;
}


.bottom-border-input {
  border: none;
  border-bottom: 1.2px solid #000000;
  outline: none;
  background: transparent;
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  line-height: 24px;
  width: 100%;
  padding: 4px 0;
}

.cancel-btn {
  border-style: none;
  background: transparent;
}

.cancel-btn span {
  font-family: Noto Sans;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000000;
}

.replymessage-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  width: 83px;
  height: 34px;
  background: #FDE802;
  color: #000000;
  border-style: none;
}

.replymessage-btn span {
  font-family: Noto Sans;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000000;
}

.reply-count button {
  border-style: none;
  width: fit-content;
  border-radius: 40px;
  background: #D9D9D9;
}

.repliescount {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Noto Sans;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000000;
}

.resubmit-btn {
  background: #FDE802;
  border-style: none;
  border-radius: 4px;
}

.resubmit-btn span {
  font-family: Noto Sans;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000000;
}`, "",{"version":3,"sources":["webpack://./src/Pages/RequestContract/requestcontract.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB;AACF;;AAEA;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;;EAEtB,eAAe;AACjB;;;AAGA;EACE,YAAY;EACZ,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".request-title span {\r\n  font-family: Noto Sans;\r\n  font-weight: 400;\r\n  font-size: 22px;\r\n  line-height: 24px;\r\n  letter-spacing: 0%;\r\n  color: #000000;\r\n}\r\n\r\n.create-contract {\r\n  width: 139px !important;\r\n  height: 40px;\r\n  width: fit-content;\r\n  border-radius: 4px;\r\n  background: #FDE802;\r\n  border-style: none;\r\n}\r\n\r\n.create-contract span {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-family: Noto Sans;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  letter-spacing: 0%;\r\n  color: #292F36;\r\n}\r\n\r\n.status-dropdown {\r\n  width: 238px;\r\n  display: flex;\r\n  align-items: center;\r\n  height: 40px;\r\n}\r\n\r\n.status-dropdown.p-dropdown {\r\n  border: 1px solid #292F36 !important;\r\n}\r\n\r\n.status-dropdown .p-dropdown-label {\r\n  font-family: 'Noto Sans', sans-serif;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  letter-spacing: 0;\r\n  color: #000;\r\n}\r\n\r\n.project-conatiner {\r\n  border-radius: 8px;\r\n  border-width: 1px;\r\n  background: #FFFFFF;\r\n  border: 1px solid #C8CED3;\r\n}\r\n\r\n.status-update {\r\n  /* width: 96px; */\r\n  padding: 12px,12px;\r\n  border-radius: 20px;\r\n  background: #ED0006;\r\n}\r\n\r\n.status-update span {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-family: Noto Sans;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  letter-spacing: 0%;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  color: #F3F3F3;\r\n}\r\n\r\n.change-requested {\r\n  width: 150px;\r\n  border-radius: 20px;\r\n  background: #1A1A1A;\r\n}\r\n\r\n.change-requested span {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-family: Noto Sans;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  letter-spacing: 0%;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  color: #F3F3F3\r\n}\r\n\r\n.completed-requested {\r\n  width: 109px;\r\n  border-radius: 20px;\r\n  background: #128807;\r\n}\r\n\r\n.completed-requested span {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-family: Noto Sans;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  letter-spacing: 0%;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  color: #F3F3F3\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .change-requested {\r\n    width: auto;\r\n    border-radius: 20px;\r\n    background: #1A1A1A;\r\n  }\r\n\r\n  .create-contract {\r\n    height: 40px;\r\n    /* width: 100%; */\r\n    border-radius: 4px;\r\n    background: #FDE802;\r\n    border-style: none;\r\n  }\r\n\r\n  contract span {\r\n    display: flex;\r\n    font-family: Noto Sans;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n    letter-spacing: 0%;\r\n    color: #292F36;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .status-dropdown {\r\n    /* width:100%; */\r\n    display: flex;\r\n    align-items: center;\r\n    height: 40px;\r\n  }\r\n}\r\n\r\n.project-title span {\r\n  font-family: Noto Sans;\r\n  font-weight: 600;\r\n  font-size: 18px;\r\n  line-height: 100%;\r\n  letter-spacing: 0%;\r\n  vertical-align: middle;\r\n  color: #292F36\r\n}\r\n\r\n.border-style {\r\n  border: 1px solid #C8CED3;\r\n}\r\n\r\n.course-title span {\r\n  font-family: Noto Sans;\r\n  font-weight: 700;\r\n  font-size: 16px;\r\n  line-height: 100%;\r\n  letter-spacing: 0%;\r\n  vertical-align: middle;\r\n  color: #565B60\r\n}\r\n\r\n.date span {\r\n  font-family: Noto Sans;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 100%;\r\n  letter-spacing: 0%;\r\n  vertical-align: middle;\r\n  color: #565B60\r\n}\r\n\r\n.date img {\r\n  height: 16px;\r\n  width: 16px;\r\n}\r\n\r\n.total-count span {\r\n  font-family: Noto Sans;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  line-height: 100%;\r\n  letter-spacing: 0%;\r\n  vertical-align: middle;\r\n  color: #292F36;\r\n}\r\n\r\n.view-btn {\r\n  border-style: none;\r\n  width: 93px;\r\n  border-radius: 4px;\r\n  background: #FDE802;\r\n}\r\n\r\n.change-btn {\r\n  border-style: none;\r\n  width: 93px;\r\n  border-radius: 4px;\r\n  background: #FDE802;\r\n}\r\n\r\n.view-btn span {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-family: Noto Sans;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  letter-spacing: 0%;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  color: #292F36;\r\n}\r\n\r\n.Creator span {\r\n  font-family: Noto Sans;\r\n  font-weight: 400;\r\n  font-size: 17px;\r\n  line-height: 100%;\r\n  letter-spacing: 0%;\r\n  vertical-align: middle;\r\n  color: #565B60;\r\n}\r\n\r\n.comment-conatiner {\r\n  background: #ffff;\r\n  border: 1px solid #999C9F;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.comment-conatiner span {\r\n  font-family: Noto Sans;\r\n  font-weight: 400;\r\n  font-size: 11px;\r\n  line-height: 16px;\r\n  letter-spacing: 0%;\r\n  color: #292F36;\r\n}\r\n\r\n.reciver-message {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 30px;\r\n  background: #999C9F;\r\n}\r\n\r\n.reciver-message span {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n  font-family: 'Noto Sans', sans-serif;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  color: #FFFFFF;\r\n}\r\n\r\n.message-text {\r\n  font-family: Noto Sans;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  letter-spacing: 0%;\r\n  color: #000000;\r\n  flex: 1;\r\n}\r\n\r\n.reply-style {\r\n  font-family: Noto Sans !important;\r\n  font-weight: 700 !important;\r\n  font-size: 14.5px !important;\r\n  line-height: 24px !important;\r\n  letter-spacing: 0% !important;\r\n  color: #000 !important;\r\n  ;\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n.bottom-border-input {\r\n  border: none;\r\n  border-bottom: 1.2px solid #000000;\r\n  outline: none;\r\n  background: transparent;\r\n  font-family: 'Noto Sans', sans-serif;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  width: 100%;\r\n  padding: 4px 0;\r\n}\r\n\r\n.cancel-btn {\r\n  border-style: none;\r\n  background: transparent;\r\n}\r\n\r\n.cancel-btn span {\r\n  font-family: Noto Sans;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  letter-spacing: 0%;\r\n  color: #000000;\r\n}\r\n\r\n.replymessage-btn {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 4px;\r\n  width: 83px;\r\n  height: 34px;\r\n  background: #FDE802;\r\n  color: #000000;\r\n  border-style: none;\r\n}\r\n\r\n.replymessage-btn span {\r\n  font-family: Noto Sans;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  letter-spacing: 0%;\r\n  color: #000000;\r\n}\r\n\r\n.reply-count button {\r\n  border-style: none;\r\n  width: fit-content;\r\n  border-radius: 40px;\r\n  background: #D9D9D9;\r\n}\r\n\r\n.repliescount {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-family: Noto Sans;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 24px;\r\n  letter-spacing: 0%;\r\n  color: #000000;\r\n}\r\n\r\n.resubmit-btn {\r\n  background: #FDE802;\r\n  border-style: none;\r\n  border-radius: 4px;\r\n}\r\n\r\n.resubmit-btn span {\r\n  font-family: Noto Sans;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  letter-spacing: 0%;\r\n  color: #000000;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
